// removed by extract-text-webpack-plugin
module.exports = {"button":"LoginButtons__button___1yK77","facebook":"LoginButtons__facebook___2biAO","google":"LoginButtons__google___15i2T","twitter":"LoginButtons__twitter___12PMC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/LoginButtons.css
// module id = 880
// module chunks = 0